// extracted by mini-css-extract-plugin
module.exports = {"button":"Detail_ModalMap_button__d3amJ","mapContainer":"Detail_ModalMap_mapContainer__1vf_A"};